import React, { useState, useEffect } from "react";
import "./othersmodule.css";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import instance from "../../ApiInstance/Inetrceptor";
import {
  CircularProgress,
  Divider,
  Grid,
  Paper,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const KeyDetails = ({ open, handleClose, keyData, Direction, Job_ref }) => {
  const [loader, setLoader] = useState(true);
  const [messageData, setMessageData] = useState(null);
  const [pdfPopover, setPdfPopover] = useState({
    open: false,
    anchorEl: null,
    pdfUrl: "",
  });
  const [openPreview, setOpenPreview] = useState(false);
  const [previewContent, setPreviewContent] = useState("");

  const handlePreviewOpen = (content) => {
    console.log("content", content);
    setPreviewContent(content);
    setOpenPreview(true);
  };

  const handlePreviewClose = () => {
    setOpenPreview(false);
    setPreviewContent("");
  };
  const copyToClipboard = (content) => {
    // Remove line numbers from the content
    const cleanContent = content
      .split("\n")
      .map((line) => line.replace(/^\d+:\s/, "")) // remove the line number at the start of each line
      .join("\n");

    // Copy the cleaned content to the clipboard
    navigator.clipboard.writeText(cleanContent).then(
      () => {
        console.log("Copied to clipboard successfully!");
      },
      (err) => {
        console.error("Could not copy text: ", err);
      }
    );
  };

  const handlePdfPopoverOpen = (event, pdfUrl) => {
    setPdfPopover({
      open: true,
      anchorEl: event.currentTarget,
      pdfUrl: pdfUrl,
    });
  };

  const handlePdfPopoverClose = () => {
    setPdfPopover({
      ...pdfPopover,
      open: false,
    });
  };
  //   const getMessage = () => {
  //     const body = {
  //       id: keyData,
  //       selected_direction: Direction,
  //     };
  //     instance
  //       .post("api/v1/Message/GetMessageDataAndPayload", body)
  //       .then((res) => {
  //         if (res?.data?.Success) {
  //           // Decode Base64 data
  //           const decodedPayloads = res.data.Value.message_Destination_Payloads.map(payload => ({
  //             ...payload,
  //             decodedContent: atob(payload.destination_payload)
  //           }));

  //           const decodedMessagePayload = atob(res.data.Value.message_payload_data);

  //           // Update state with decoded data
  //           setMessageData({
  //             ...res.data.Value,
  //             message_Destination_Payloads: decodedPayloads,
  //             message_payload_data: decodedMessagePayload
  //           });
  //         } else {
  //           setMessageData(null);
  //         }
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //         setMessageData(null);
  //       })
  //       .finally(() => {
  //         setLoader(false);
  //       });
  //   };
  const getMessage = () => {
    const body = {
      id: keyData,
      selected_direction: Direction,
    };
    instance
      .post("api/v1/Message/GetMessageDataAndPayload", body)
      .then((res) => {
        if (res?.data?.Success) {
          // Decode Base64 data
          const decodedPayloads =
            res.data.Value.message_Destination_Payloads.map((payload) => {
              const decodedContent = atob(payload.destination_payload);
              // Check for <ImageData> elements and create PDF Blob URLs
              const pdfBlobs = decodeImageDataToPdf(decodedContent);
              return {
                ...payload,
                decodedContent,
                pdfBlobs,
              };
            });

          const decodedMessagePayload = atob(
            res.data.Value.message_payload_data
          );

          // Update state with decoded data
          setMessageData({
            ...res.data.Value,
            message_Destination_Payloads: decodedPayloads,
            message_payload_data: decodedMessagePayload,
          });
        } else {
          setMessageData(null);
        }
      })
      .catch((err) => {
        console.log(err);
        setMessageData(null);
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const decodeImageDataToPdf = (xmlContent) => {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlContent, "text/xml");
    const imageDataElements = xmlDoc.getElementsByTagName("ImageData");
    const pdfBlobs = [];

    for (let i = 0; i < imageDataElements.length; i++) {
      const base64Data = imageDataElements[i].textContent;
      const binaryData = atob(base64Data);
      const byteArray = new Uint8Array(binaryData.length);
      for (let j = 0; j < binaryData.length; j++) {
        byteArray[j] = binaryData.charCodeAt(j);
      }
      const blob = new Blob([byteArray], { type: "application/pdf" });
      pdfBlobs.push(URL.createObjectURL(blob));
    }

    return pdfBlobs;
  };

  const displayXmlWithLineNumbers = (xmlContent) => {
    if (!xmlContent) return null; // Return early if xmlContent is null or undefined

    const lines = xmlContent.split("\n");
    let lineNumber = 1;

    const numberedLines = lines.map((line, index) => {
      if (line.trim() !== "") {
        return (
          <div key={`line-${index}`}>
            <span
              style={{ fontWeight: "bold", marginRight: "8px", color: "black" }}
            >
              {lineNumber++}:
            </span>{" "}
            {line}
          </div>
        );
      } else {
        return (
          <div key={`line-${index}`}>
            {/* Render a non-breaking space for empty lines */}
            &nbsp;
          </div>
        );
      }
    });

    return numberedLines;
  };
  const renderPreviewDialogContent = () => {
    return (
      <Dialog
        open={openPreview}
        onClose={handlePreviewClose}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>
          <IconButton
            onClick={handlePreviewClose}
            sx={{ position: "absolute", right: 0, top: 0 }}
          >
            <CancelIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <pre
            style={{
              whiteSpace: "pre-wrap",
              fontFamily: "monospace",
              lineHeight: "1.4",
            }}
          >
            {displayXmlWithLineNumbers(previewContent)}
          </pre>
        </DialogContent>
      </Dialog>
    );
  };
  const renderDialogContentForT = () => {
    if (loader) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100px",
          }}
        >
          <CircularProgress />
        </div>
      );
    }

    if (messageData) {
      return (
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            md={6}
            style={{ padding: "0.1rem", borderRight: "1px solid #e5e5e5" }}
          >
            <Paper style={{ padding: "0.5rem" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <strong>Input Message</strong>
                <div>
                <IconButton
                  onClick={() =>
                    handlePreviewOpen(messageData.message_payload_data)
                  }
                >
                  <FullscreenIcon />
                </IconButton>
                <IconButton
                  onClick={() =>
                    copyToClipboard(messageData.message_payload_data)
                  }
                >
                  <ContentCopyIcon />
                </IconButton></div>
              </div>
              <strong>Message Payload Data:</strong>

              {messageData.message_payload_data ? (
                <div
                  style={{
                    height: "620px",
                    overflowX: "hidden",
                    wordWrap: "break-word",
                  }}
                >
                  {displayXmlWithLineNumbers(messageData.message_payload_data)}
                </div>
              ) : (
                <div>No message payload data found</div>
              )}
            </Paper>
          </Grid>

          <Grid item xs={12} md={6} style={{ padding: "0.1rem" }}>
            <Paper style={{ padding: "0.5rem" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <strong>Output Message</strong>
                <div>
                <IconButton
                  onClick={() =>
                    handlePreviewOpen(
                      messageData.message_Destination_Payloads[0].decodedContent
                    )
                  }
                >
                  <FullscreenIcon />
                </IconButton>
                <IconButton
                  onClick={() =>
                    copyToClipboard(
                      messageData.message_Destination_Payloads
                        .map((payload) => payload.decodedContent)
                        .join("\n")
                    )
                  }
                >
                  <ContentCopyIcon />
                </IconButton></div>
              </div>
              <strong>Destination Payloads:</strong>
              {messageData.message_Destination_Payloads &&
              messageData.message_Destination_Payloads.length > 0 ? (
                messageData.message_Destination_Payloads.map(
                  (payload, index) => (
                    <div
                      key={index}
                      style={{
                        height: "620px",
                        overflowX: "hidden",
                        wordWrap: "break-word",
                      }}
                    >
                      {displayXmlWithLineNumbers(payload.decodedContent)}
                    </div>
                  )
                )
              ) : (
                <div>No destination payloads found</div>
              )}
            </Paper>
          </Grid>
        </Grid>
      );
    }

    return <div>No data found</div>;
  };
  const renderDialogContentForF = () => {
    if (loader) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100px",
          }}
        >
          <CircularProgress />
        </div>
      );
    }

    if (messageData) {
      return (
        <Grid container>
          <Grid
            item
            xs={12}
            md={6}
            style={{ padding: "0.1rem", borderRight: "1px solid #e5e5e5" }}
          >
            <Paper style={{ padding: "0.5rem" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <strong>Message Trucker:</strong>
                <div>
                <IconButton
                  sx={{ marginLeft: "13rem" }}
                  onClick={() =>
                    handlePreviewOpen(messageData.message_payload_data)
                  }
                >
                  <FullscreenIcon />
                </IconButton>
                <IconButton
                  onClick={() =>
                    copyToClipboard(messageData.message_payload_data)
                  }
                >
                  <ContentCopyIcon />
                </IconButton></div>
              </div>
              {messageData.message_payload_data ? (
                <div
                  style={{
                    height: "620px",
                    overflowX: "hidden",
                    wordWrap: "break-word",
                  }}
                >
                  {displayXmlWithLineNumbers(messageData.message_payload_data)}
                </div>
              ) : (
                <div>No message payload data found</div>
              )}
            </Paper>
          </Grid>

          <Grid item   xs={12}
            md={6} style={{ padding: "0.1rem" }}>
            <Paper style={{ padding: "0.5rem" }}>
              <strong>Converted Message:</strong>
              {messageData.message_Destination_Payloads &&
              messageData.message_Destination_Payloads.length > 0 ? (
                <TableContainer component={Paper} sx={{ height: 635 }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>S.No.</TableCell>
                        <TableCell>Destination Payload</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {messageData.message_Destination_Payloads
                        .reverse()
                        .map((payload, index) => (
                          <TableRow key={index}>
                            <TableCell>
                              <div className="d-flex justify-content-center align-items-center flex-column"><IconButton
                                onClick={() =>
                                  handlePreviewOpen(
                                    messageData.message_Destination_Payloads[
                                      index
                                    ].decodedContent
                                  )
                                }
                              >
                                <FullscreenIcon />
                              </IconButton>
                              <IconButton
                                onClick={() =>
                                  copyToClipboard(
                                    messageData.message_Destination_Payloads[
                                      index
                                    ].decodedContent
                                  )
                                }
                              >
                                <ContentCopyIcon />
                              </IconButton>
                              {payload.pdfBlobs.length > 0
                                ? payload.pdfBlobs.map((blobUrl, pdfIndex) => (
                                    <IconButton
                                      key={pdfIndex}
                                      onClick={(event) =>
                                        handlePdfPopoverOpen(event, blobUrl)
                                      }
                                    >
                                      <PictureAsPdfIcon />
                                    </IconButton>
                                  ))
                                : ""}
                              <br />
                              <span>{index + 1 + "."}</span></div>
                            </TableCell>
                            <TableCell>
                              <div
                                style={{
                               
                                  wordWrap: "break-word",
                                  whiteSpace: "pre-wrap",
                                }}
                              >
                                {displayXmlWithLineNumbers(
                                  payload.decodedContent
                                )}
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <div>No destination payloads found</div>
              )}
            </Paper>
          </Grid>
        </Grid>
      );
    }

    return <div>No data found</div>;
  };
  useEffect(() => {
    if (open) {
      setLoader(true);
      getMessage();
    }
  }, [keyData, open]);

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth={true}
        sx={{ "& .MuiDialog-paper": { width: "80%", maxWidth: "none" } }}
      >
        <DialogTitle
          sx={{
            display: "flex",
             justifyContent: "space-between",
            alignItems: "center",
            fontSize: "1.5rem",
          }}
        >
          {/* <span>{Direction === 'T' ? `To Message Details(${keyData} ${Job_ref ? ",":''}${Job_ref ?? ''})` :
             `Fro Message Details(${keyData} ${Job_ref ? ",":''}${Job_ref ?? ''})`}</span> */}
          {Direction === "T" ? (
            <div>
              <strong>To Message Details</strong>
              <span
                style={{
                  fontSize: "1rem",
                  marginLeft: "10px",
                }}
              >
                ({keyData}
                {Job_ref ? "," : ""}
                {Job_ref ?? ""})
              </span>
            </div>
          ) : (
            <div>
              <strong>Fro Message Details</strong>
              <span
                style={{
                  fontSize: "1rem",
                  marginLeft: "10px",
                }}
              >
                ({keyData}
                {Job_ref ? "," : ""}
                {Job_ref ?? ""})
              </span>
            </div>
          )}
          <IconButton onClick={handleClose}>
            <CancelIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {Direction === "T"
            ? renderDialogContentForT()
            : renderDialogContentForF()}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="secondary" onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Popover
        open={pdfPopover.open}
        anchorEl={pdfPopover.anchorEl}
        onClose={handlePdfPopoverClose}
        anchorOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
      >
        <iframe
          src={pdfPopover.pdfUrl}
          width="1000px"
          height="800px"
          title="PDF Viewer"
          style={{ border: "none" }}
        />
      </Popover>
      {renderPreviewDialogContent()}
    </>
  );
};

export default KeyDetails;
